module.exports = ".admin-layout-wrapper {\r\n    margin-top: -72px;\r\n}"